import isMobileBrowser from 'is-mobile'

import { Columns, LoadingModule } from '@domain-group/suit-theme'

import type { ProviderPriceListModel } from '@models/types'

import usePriceListManager from '../../hooks/usePriceListManager'

import AddProduct from './AddProduct'
import PriceListItemDetail from './PriceListItemDetail'
import ProductList from './ProductList'

const isMobile = isMobileBrowser()

interface EditorProps {
  loading: boolean,
  priceListManagerPayload: ReturnType<typeof usePriceListManager>,
  providerPriceList: ProviderPriceListModel,
}

const Editor = (props: EditorProps) => {
  const {
    loading,
    priceListManagerPayload: {
      assignedServiceProductIds,
      callbacks: {
        showCreateOrEditProviderPriceListItemModal,
        showCreateOrEditProviderPriceListItemOptionModal,
        showCreateOrEditProviderPriceListItemOptionValueModal,
      },
      isMaster,
      selectedPriceListItem,
      unassignedServiceProductIds,
    },
    providerPriceList,
  } = props

  const mainColumnProps = isMobile ? {} : { marginLeft: 16, marginRight: 0, width: 'calc(100% - 375px)' }

  return (
    <>
      <Columns.Sidebar>
        <ProductList
          assignedServiceProductIds={assignedServiceProductIds}
          callbacks={{
            showCreateOrEditProviderPriceListItemModal,
          }}
          isMaster={isMaster}
          providerPriceList={providerPriceList}
        />

        {isMaster && (
          <AddProduct
            callbacks={{
              showCreateOrEditProviderPriceListItemModal,
            }}
            providerPriceList={providerPriceList}
            unassignedServiceProductIds={unassignedServiceProductIds}
          />
        )}
      </Columns.Sidebar>

      <Columns.Main boxProps={mainColumnProps}>
        <LoadingModule loading={loading} times={3} />

        {!!selectedPriceListItem.id && (
          <PriceListItemDetail
            callbacks={{
              showCreateOrEditProviderPriceListItemOptionModal,
              showCreateOrEditProviderPriceListItemOptionValueModal,
            }}
            isMaster={isMaster}
            // @ts-expect-error TS2322
            providerPriceList={providerPriceList}
            providerPriceListItemId={selectedPriceListItem.id}
          />
        )}
      </Columns.Main>
    </>
  )
}

export default Editor
